import React from "react";

import "./BrightmileTheme.scss";

const BrightmileTheme = () => <></>;

export default BrightmileTheme;
